import { formatDateUtil } from "@utils/date.util";
import { PRIMARY_KEY } from "@constants/app.constants";

const tableTitle = "Orders List";
const keyColumn = PRIMARY_KEY;
const menuUrl = "orders";
const tableColumn = [
  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
  {
    id: "order_id",
    numeric: false,
    disablePadding: false,
    label: "Order ID",
  },
  {
    id: "company_name",
    numeric: false,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "mobile",
    numeric: false,
    disablePadding: false,
    label: "Mobile",
  },
  {
    id: "product_count",
    numeric: false,
    disablePadding: false,
    label: "Product Count",
  },
  {
    id: "order_value",
    numeric: false,
    disablePadding: false,
    label: "Total Amount",
  },
  {
    id: "status_name",
    numeric: false,
    disablePadding: false,
    label: "Order Status",
  },
  {
    id: "payment_status",
    numeric: false,
    disablePadding: false,
    label: "Payment Status",
    isBadge: true,
    primaryKey: keyColumn,
    badgeText: {
      "PAID": "Paid",
      "NOT PAID": "Not Paid",
    },
    badgeColor: {
      "PAID": "success",
      "NOT PAID": "danger",
    },
  },
];
const breadCrumbs = [{ name: "Orders", menu_url: "/orders" }];

const filters = [
  {
    name: "company_name",
    id: "company_name",
    label: "Company Name",
    type: "TEXT",
    value: "",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export { tableTitle, keyColumn, tableColumn, breadCrumbs, menuUrl, filters };
